@if (inputType === 'search') {
  <form
    class="mb-4"
    [formGroup]="inputForm"
    novalidate>
    <label class="input input--search">
      <span class="input__input-group">
        <span class="input__search-icon">
          <ingsv-adm-icons [icon]="'search'"></ingsv-adm-icons>
        </span>
        <input
          placeholder="Søk på kundenavn, kundebehandler eller hva som helst"
          class="input__input input__input--text"
          type="text"
          formControlName="input" />
      </span>
    </label>
  </form>
}